<template>
  <v-card sheet>
    <v-card-text class="pa-0">
      <v-container>
        <v-row class="layout pa-0">
          <v-col sm="6" class="flex">
            <div class="layout column ma-0 justify-center align-center">
              <v-icon size="52px" :class="[colors[ind] + '--text']">{{
                stat.icon
              }}</v-icon>
            </div>
          </v-col>
          <v-col
            sm="6"
            class="flex text-sm-center py-3"
            :class="[colors[ind], 'white--text']"
          >
            <div v-if="len" class="headline">
              <div>{{ len }}</div>
            </div>
            <div v-else class="headline">
              <div>-</div>
              <!-- <v-progress-circular
                indeterminate
                color="amber"
              ></v-progress-circular> -->
            </div>
            <span class="caption">{{ stat.name }}</span>
          </v-col>
        </v-row>
      </v-container>
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  data() {
    return {
      colors: [
        "indigo",
        "orange",
        "green",
        "red",
        "indigo",
        "teal",
        "orange",
        "brown",
        "deep-orange",
        "blue-grey",
        "cyan",
      ],
      currentColor: "",
    };
  },
  methods: {},
  props: {
    stat: {},
    ind: Number,
    len: Number,
  },
};
</script>